import { render, staticRenderFns } from "./SubjectList.vue?vue&type=template&id=af03a43e"
import script from "./SubjectList.vue?vue&type=script&lang=ts"
export * from "./SubjectList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports